var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nav-link__wrapper"},[(_setup.nav.entity === _setup.globalEntities.projects)?_c('router-link',{staticClass:"nav-link__link",attrs:{"to":{
            name: _setup.routeNames.project,
            params: {
                id: _setup.nav.id,
            },
            query: {
                initialTab: _setup.navTab,
            },
        },"target":"_blank"}},[_vm._v(" "+_vm._s(_setup.navigationText)+" ")]):(_setup.nav.entity === _setup.globalEntities.clients)?_c('router-link',{staticClass:"nav-link__link",attrs:{"to":{
            name: _setup.routeNames.editClient,
            params: {
                clientId: _setup.nav.id,
            },
            query: {
                initialTab: _setup.navTab,
            },
        },"target":"_blank"}},[_vm._v(" "+_vm._s(_setup.navigationText)+" ")]):_c('router-link',{staticClass:"nav-link__link",attrs:{"to":{
            name: _setup.nav.entity,
        },"target":"_blank"}},[_vm._v(" "+_vm._s(_setup.navigationText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }